export default {
  NOTIFICATIONS: ({ notifications }) => notifications,
  ERROR: ({ error }) => error,
  HAS_ERROR: ({ error }) => Boolean(error),
};
